/* eslint-disable import/prefer-default-export */
import SettingsActions from "redux-react/actions/settingsActions";
/**
 * Query a resource with promise
 * @param {string} code - Code of the resource
 * @returns {Promise} - Promise with the resource
 */
export async function getResource(dispatch, code) {
	return new Promise(resolve => {
		dispatch(
			SettingsActions.getResource(
				code,
				res => {
					resolve(res.resource);
				},
				err => {
					resolve({});
				}
			)
		);
	});
}
